<template>
  <div dir="rtl">
    <div class="has-text-right">
      <div v-for="(field, index) in fields" :key="index" class="columns">
        <div class="column is-one-third has-text-weight-bold is-capitalized">
          {{ field.name }}:
        </div>
        <blockquote class="column is-family-code">
          {{ field.value }}
        </blockquote>
      </div>
    </div>
    <br />
    <div class="columns">
      <div class="column is-4">
        <button class="button" @click="openPasswordResetModal">
          Reset Password
        </button>
      </div>
    </div>
  </div>
</template>
<script>
// libraries
import { mapMutations } from 'vuex'

export default {
  name: 'admin-list-info',
  props: ['payload'],
  data () {
    return {
      staged_admin: {},
      labels: [
        {
          name: 'שם מלא',
          key: 'full_name'
        },
        {
          name: 'שם פרטי',
          key: 'first_name'
        },
        {
          name: 'שם משפחה',
          key: 'last_name'
        },
        {
          name: 'תואר',
          key: 'title'
        },
        {
          name: 'מספר טלפון',
          key: 'phone_number'
        },
        {
          name: 'מספר טלפון במשרד',
          key: 'office_phone_number'
        },
        {
          name: 'אמייל',
          key: 'email'
        },
        {
          name: 'אמייל משרד',
          key: 'common_email'
        },
        {
          name: 'אתר',
          key: 'website'
        },
        {
          name: 'סטטוס',
          key: 'status'
        }
      ]
    }
  },
  computed: {
    fields () {
      return this.labels.map(label => ({
        name: label.name,
        value: this.staged_admin[label.key]
      }))
    }
  },
  async created () {
    try {
      const r = await this.$network_utils.getAdmin({ id: this.payload.data.id })
      this.staged_admin = r
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    openPasswordResetModal () {
      this.create({
        designator: 'reset-password',
        component_name: 'ResetPassword',
        id: this.payload.data.user_id,
        modal_title: this.staged_admin.full_name + ' איפוס סיסמא עבור '
      })
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
